import Vue from 'vue'
import ResourceService from './resource.service'

class TankerTypeService extends ResourceService {
  static get resource() {
    return 'tanker-type'
  }

  static search(params) {
    const url = `${this.resource}`

    return new Promise((resolve, reject) => {
      Vue.axios
        .get(url, { params })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error))
    })
  }

  static getById(id) {
    const url = `${this.resource}/${id}`

    return new Promise((resolve, reject) => {
      Vue.axios
        .get(url)
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error))
    })
  }

  static create(data) {
    return this.post(data)
  }

  static delete(id) {
    const url = `${this.resource}/${id}`

    return new Promise((resolve, reject) => {
      Vue.axios
        .delete(url)
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error))
    })
  }
}

export default TankerTypeService